export const PHONE_DISPLAY = "(647) 507-3945";
export const PHONE_TEL = "tel:+16475073945";

export const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const AREAS = [
    { label: "Toronto — Downtown", slug: "toronto" },
    { label: "Toronto — Midtown", slug: "toronto" },
    { label: "Toronto — Uptown", slug: "toronto" },
    { label: "Scarborough", slug: "scarborough" },
    { label: "North York", slug: "north-york" },
    { label: "Etobicoke", slug: "etobicoke" },
    { label: "Mississauga", slug: "mississauga" },
    { label: "Brampton", slug: "brampton" },
    { label: "Vaughan", slug: "vaughan" },
    { label: "Markham", slug: "markham" },
    { label: "Richmond Hill", slug: "richmond-hill" },
    { label: "Pickering", slug: "pickering" },
    { label: "Ajax", slug: "ajax" },
    { label: "Whitby", slug: "whitby" },
    { label: "Oakville", slug: "oakville" },
    { label: "Newmarket", slug: "newmarket" },
];

export const REVIEWS = [
    {
        author: "Frank M.",
        area: "North York",
        text: "Simple and straightforward. Came with cash and took my car away on a flatbed truck. Best car buyer in the GTA.",
    },
    {
        author: "Elena K.",
        area: "Scarborough",
        text: "We made the deal over the phone, they gave me a great price and when the tow driver arrived he handed me the cash in an envelope. Signed the paper and done!",
    },
    {
        author: "Dave R.",
        area: "Etobicoke",
        text: "Super fast response! Called at 9 AM and the car was towed away with cash in my hand by noon. Outstanding service.",
    },
    {
        author: "Priya S.",
        area: "Brampton",
        text: "Great experience! Fast response, super efficient, easy to deal with and a very fair price for my old Corolla. Thank you!",
    },
    {
        author: "Marc T.",
        area: "Mississauga",
        text: "Excellent service. Picked up my old scrap car right on the scheduled time, in the middle of a snowstorm. True professionals.",
    },
    {
        author: "Sandra L.",
        area: "Vaughan",
        text: "The easiest way to sell an old scrap car. One call, one visit, cash in hand. Highly recommend these guys.",
    },
];

export const FAQS = [
    {
        q: "What are your opening hours to sell my car?",
        a: "We are open 7 days a week — call us any day from 7 AM to 8 PM, including weekends and holidays.",
    },
    {
        q: "How does the scrap car removal process work?",
        a: `Simply give us a call at ${PHONE_DISPLAY}. Our agent asks a few quick questions about your car, gives you an instant offer, and schedules a pickup — cash in hand on arrival.`,
    },
    {
        q: "When should I scrap my car?",
        a: "As soon as it becomes an inconvenience — repair bills piling up, failed safety, or just taking up space. We turn that headache into cash, fast.",
    },
    {
        q: "What determines the value I'll get for my scrap car?",
        a: "Value depends on the year, make, model, weight, completeness (engine, transmission, catalytic converter), current scrap metal market rates, and overall condition.",
    },
    {
        q: "I want to sell a used car that is still running — will I only get scrap price?",
        a: "No. We quote every vehicle individually. Running cars, even recent models in good condition, get competitive cash offers well above scrap value.",
    },
    {
        q: "Will you pick up my broken-down car even if it's not running?",
        a: "Absolutely. Running or not, missing wheels, wrecked or dead on the driveway — we tow it away free of charge and pay you cash.",
    },
    {
        q: "Will you pick up my car in any weather condition?",
        a: "Of course. Our flatbed drivers operate year-round across Toronto and the GTA — rain, snow or ice, the process stays fast and simple.",
    },
    {
        q: "Can I keep certain parts of the vehicle?",
        a: "Yes, nothing stops you. Just let us know when you call — missing major components may adjust the final quote.",
    },
    {
        q: "Can I sell my car for scrap if there is still an active lien on it?",
        a: "In most cases, no — an active lien usually needs to be resolved before a licensed buyer can legally purchase the vehicle. Call us and we'll help you check your options.",
    },
];
